// src/lib/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCGpayz4xlsnH-ZpjU0MYfbRcBEo8fORBo",
  authDomain: "alpine-realm-473117-f9.firebaseapp.com",
  projectId: "alpine-realm-473117-f9",
  storageBucket: "alpine-realm-473117-f9.firebasestorage.app",
  messagingSenderId: "662190215206",
  appId: "1:662190215206:web:57679bfedbb1255e1e16e7",
  measurementId: "G-DX7RGQYF1J",
};

const app = initializeApp(firebaseConfig);

/** Set when the browser supports GA; stays null in some WebViews / strict privacy (avoids console noise). */
export let analytics = null;
void isSupported()
  .then((ok) => {
    if (ok) analytics = getAnalytics(app);
  })
  .catch(() => {});

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
if (process.env.NODE_ENV === "development" && process.env.REACT_APP_FUNCTIONS_EMULATOR === "1") {
  try {
    connectFunctionsEmulator(functions, "localhost", 5001);
  } catch (_) {
    /* already connected */
  }
}
export default app;
